import { BaseApi } from './BaseApi';

export interface IModelApi<T, ID = string> {
  getOne(id: ID): Promise<T>;
}

export abstract class ModelApi<T, ID = string> extends BaseApi implements IModelApi<T, ID> {
  public getOne = (id: ID) => this.get<T>(`/${id}`);
}
